<template>
  <div>
    <b-container>
      <b-row>
        <b-col sm="12">
          <div class="bg-white px-4 py-2 mb-5 filter-bar">
            <div class="filter-panel row align-items-center justify-content-center">
              <filter-group
                v-for="group in searchFilters.groups"
                :key="group.id"
                :group-label="group.label"
                :group-id="group.id"
                :group-type="group.type"
                class="group"
              ></filter-group>

              <b-button
                v-if="searchType == 'Button'"
                squared
                variant="primary"
                @click="changeSearchTime"
                >Search</b-button
              >
              <div class="col-12 col-md my-1">
                <b-button
                  class="reset-search w-100"
                  aria-label="Reset"
                  variant="outline-primary"
                  @click="resetSearch"
                >
                  Reset
                </b-button>
              </div>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-container>
    <user-actions-component :selected-filters="selectedFilters"></user-actions-component>

    <!-- <quick-links v-if="displayQuickLinks"></quick-links> -->
    <wordpress-feed v-if="displayQuickLinks"></wordpress-feed>
    <section
      v-if="!displayQuickLinks"
      class="bg-light py-3"
      aria-label="Number of results and filters selected"
    >
      <b-container>
        <b-row class="align-items-center justify-content-between">
          <b-col sm="12" md="8">
            <div class="d-flex align-items-center justify-content-between">
              <div class="total-results d-flex">
                Total:
                <span id="total" class="ml-1">{{ services.totalElements }}</span>
              </div>
              <div id="selected-filters" class="selected-filters ml-4">
                <b-button
                  v-for="filter in selectedFilters"
                  :key="filter.paramId"
                  variant="outline-primary"
                  pill
                  size="sm"
                  class="m-1"
                  @click="unsetFilter(filter.paramId)"
                  >{{ filter.label }}: {{ filter | showSelectedName }}
                  <b-icon icon="x"></b-icon>
                </b-button>
              </div>
            </div>
          </b-col>
          <map-buttons :serv="services.content"></map-buttons>
        </b-row>
        <map-component v-if="services.content.length > 1" :serv="services.content"></map-component>
      </b-container>
    </section>
    <section v-if="!displayQuickLinks" class="bg-white py-3" aria-label="search results">
      <b-container>
        <b-row>
          <b-col sm="12">
            <h2 class="sr-only">Search results</h2>
          </b-col>
          <b-col sm="12">
            <b-row class="py-4">
              <div v-if="services.content.length < 1" class="text-center w-100">
                <p>
                  Your selections have not returned any results. Please remove one of the filters
                  above or try a new search.
                  <a href="/help-with-using-this-website/">Need help with searching?</a>
                </p>
              </div>
              <service-list
                v-for="service in services.content"
                :key="service.id"
                :service="service"
              >
              </service-list>
              <b-overlay :show="loading" no-wrap> </b-overlay>
            </b-row>
            <pagination :current-page="currentPage"></pagination>
          </b-col>
        </b-row>
      </b-container>
    </section>
  </div>
</template>
<script>
import store from '@/store/'
import { mapGetters } from 'vuex'
import ServiceList from './list/ServiceList.vue'
import Pagination from './Pagination.vue'
import FilterGroup from './filters/FilterGroup.vue'
import MapComponent from './map/MapComponent.vue'
import MapButtons from './map/MapButtons.vue'
import WordpressFeed from '@/components/elements/WordpressFeed.vue'
import UserActionsComponent from './elements/UserActionsComponent.vue'
import showSelectedName from '@/filters/showSelectedName.js'
import { mapState } from 'vuex'
import {
  FETCH_SERVICES,
  SEND_FILTER_SELECTED,
  SEND_SEARCH_TIME,
  FETCH_FILTERS_SETTINGS,
} from '@/store/actions.type.js'
import VueRouter from 'vue-router'
const { isNavigationFailure, NavigationFailureType } = VueRouter
import { APP_CONFIG } from '../config/config'

export default {
  name: 'Search',
  components: {
    ServiceList,
    Pagination,
    FilterGroup,
    MapComponent,
    MapButtons,
    WordpressFeed,
    UserActionsComponent,
  },
  filters: {
    showSelectedName,
  },
  data() {
    return {
      show: false,
      loading: true,
      displayQuickLinks: null,
      canceler: null,
      controller: null,
      pageCheck: 1,
    }
  },
  computed: {
    searchType() {
      if (APP_CONFIG.searchType) return APP_CONFIG.searchType
      return 'Button'
    },
    currentPage() {
      if (this.$route.query.page) {
        return parseInt(this.$route.query.page)
      }
      if (this.services.number) {
        return parseInt(this.services.number)
      }
      return 1
    },
    selectedFilters() {
      if (!this.searchFilters) return
      return this.searchFilters.filterSettings.filter((filter) => {
        if (filter.selected !== '' && !filter.ignore && this.$route.query[filter.paramId])
          return filter.selected.length > 0
      })
    },
    ...mapGetters(['services']),
    ...mapState(['searchFilters']),
  },
  watch: {
    $route(to, from) {
      if (to.fullPath !== from.fullPath) {
        // Check for page change
        this.pageCheck = from.query.page
        if (to.fullPath.includes('?')) this.displayQuickLinks = false
        if (APP_CONFIG.searchType == 'Change') this.goSearch()
      }
    },
  },
  mounted() {
    this.controller = new AbortController()
    this.canceler = this.controller.signal
    if (location && location.href.includes('?')) {
      this.displayQuickLinks = false
    } else {
      this.displayQuickLinks = true
    }
    this.loading = true
    if (!this.searchFilters) store.dispatch(FETCH_FILTERS_SETTINGS)

    store
      .dispatch(FETCH_SERVICES, {
        params: this.$route.query,
        canceler: this.canceler,
      })
      .then(() => {
        this.loading = false
      })
  },
  methods: {
    goSearch() {
      this.loading = true
      let query = Object.assign({}, this.$route.query)
      // Check for page change
      if (this.$route.query.page == this.pageCheck) {
        query.page = 1
      }

      if (query.include) delete query.include
      this.$router.push({ path: this.$route.path, query: query }).catch((failure) => {
        if (isNavigationFailure(failure, NavigationFailureType.redirected)) {
          // show a small notification to the user
          showToast('Login in order to access the admin panel')
        }
      })
      this.controller.abort()
      this.controller = new AbortController()
      this.canceler = this.controller.signal
      store
        .dispatch(FETCH_SERVICES, {
          params: this.$route.query,
          canceler: this.canceler,
        })
        .then(() => {
          this.loading = false
        })
    },
    /**
     * This changes the watched var which intiates search in button click mode.
     */
    changeSearchTime() {
      this.loading = true
      store.dispatch(SEND_SEARCH_TIME, Date.now()).then(() => {
        this.goSearch()
      })
    },
    unsetFilter(paramId) {
      let query = Object.assign({}, this.$route.query)
      query.page = 1

      // this.$router.push({ path: this.$route.path, query: query })

      this.loading = true
      store
        .dispatch(SEND_FILTER_SELECTED, {
          paramId: paramId,
          selected: 'clear',
        })
        .then(() => {
          store.dispatch(FETCH_SERVICES, this.$route.query).then(() => {
            this.loading = false
          })
        })
    },
    resetSearch() {
      let self = this
      this.selectedFilters.forEach(function (filter) {
        self.unsetFilter(filter.paramId)
      })
    },
  },
}
</script>
